import React, { useEffect, useState } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";

const getHijriDate = () => {
  try {
    const date = new Date();
    return new Intl.DateTimeFormat("ar-SA-u-ca-islamic", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(date);
  } catch {
    return "١١ محرم ١٤٤٧ هـ";
  }
};

const getGregorianDate = () => {
  const date = new Date();
  const weekdays = ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
  const weekday = weekdays[date.getDay()];

  const options = { day: "2-digit", month: "long", year: "numeric" };
  const gregDate = new Intl.DateTimeFormat("ar-EG", options).format(date);

  return `${weekday} | ${gregDate}`;
};

const DateDisplay = () => {
  const [gregorianDate, setGregorianDate] = useState("");
  const [hijriDate, setHijriDate] = useState("");

  useEffect(() => {
    setGregorianDate(getGregorianDate());
    setHijriDate(getHijriDate());
  }, []);

  return (
    <div
      style={{
        background: "#304E50",
        color: "#fff",
        padding: "10px 20px",
        textAlign: "center",
        fontSize: "1rem",
        direction: "rtl",
        borderBottom: "1px solid #304E50",
      }}
    >
      <p style={{ margin: 0 }}>
        <FaRegCalendarAlt style={{ marginLeft: "8px", color: "#c49a6c" }} />
        {gregorianDate} | {hijriDate}
      </p>
    </div>
  );
};

export default DateDisplay;
